/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  convertTravelTime,
  formatTimeString,
  formatTimeStringAmPmFormat,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import StopOverInfo from '../one-way/StopOverInfo';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';

export default function ResultCardFlightInfo({
  flight,
  isOnward,
  userSelectedFare,
  searchRequest,
  isAmPmFormat,
  hideLegInfo,
}) {
  const getTerminal = (city, terminal) => (
    <span
      style={{ fontSize: '12px', color: '#768391' }}
      className="terminalNumber"
    >
      {city}
      {terminal !== '' && terminal !== 'null' && terminal !== '-' && (
        <>-{terminal}</>
      )}
    </span>
  );
  const getFlightNumbers = (flt) => {
    const flightnumbers = [];
    flt.flightlegs.forEach((leg, lgindex) => {
      flightnumbers.push(
        isOnward
          ? `${userSelectedFare.flightCarrier[lgindex]}-${leg.flightnumber}`
          : `${userSelectedFare.flightCarrierReturn[lgindex]}-${leg.flightnumber}`,
      );
    });
    const uniqueFltNumbers = Array.from(new Set(flightnumbers));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  };
  const getEquipment = (flt) => {
    const flightEquipment = [];
    flt.flightlegs.forEach((leg) => {
      flightEquipment.push(`${leg.equipment}`);
    });
    const uniqueFltNumbers = Array.from(new Set(flightEquipment));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  };
  const getOperatedBy = (flt) => {
    const flightOperatedBy = [];
    flt.flightlegs.forEach((leg) => {
      flightOperatedBy.push(`${leg.operatedby}`);
    });
    const uniqueFltNumbers = Array.from(new Set(flightOperatedBy));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  };

  return (
    <Row
      className={`spacing-0 flex-1 flight-info_flight-details ${
        isOnward ? 'pb-2' : 'mt-2'
      }`}
      style={{ borderBottom: isOnward ? '1px solid #e9e9e9' : 'none' }}
    >
      <Col
        lg={4}
        md={4}
        sm={4}
        xs={4}
        className="d-flex flex-sm-row flex-column"
      >
        <div className="flight-info_flight-details">
          <div className="d-flex">
            <div className="d-flex me-2 flight-image">
              <AppFlightLogo
                carrier={flight.flightlegs[0].carrier.substring(0, 2)}
                className="vertical-bottom"
                height="30"
                width="30"
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-column flight-name">
          <span className="flight-company flightCompanyName ">
            {flight.flightlegs[0].validatingcarriername}
          </span>
          <span className="fs-10 flight-number flightNumber ">
            {getFlightNumbers(flight)}
          </span>
          {!isMobileWidth() && (
            <>
              {getEquipment(flight) !== '' && (
                <span className="fs-8 fw-300 grey-color equipmentDetials">
                  {getEquipment(flight)?.trim()?.toUpperCase() === 'BUS' ||
                  getEquipment(flight)?.trim()?.toUpperCase() === 'BUS TRANSFER'
                    ? 'Bus Transfer'
                    : `Equipment: ${getEquipment(flight)}`}
                </span>
              )}
              {getOperatedBy(flight) !== '' && (
                <span className="fs-8 fw-300 grey-color OperatedBy">
                  Operated By: {getOperatedBy(flight)}
                </span>
              )}
              {searchRequest.searchtype === 'seriesfares' && (
                <span className="fs-8  red-color">
                  Frozen fares are 100% non-refundable
                </span>
              )}
            </>
          )}
        </div>
      </Col>
      <Col lg={8} md={8} sm={8} xs={8}>
        {!isMobileWidth() ? (
          <Row>
            <Col
              lg={5}
              md={5}
              sm={5}
              xs={5}
              className="d-flex justify-content-start"
            >
              <div className="d-flex flex-column">
                <span className="title fw-600 depTime">
                  {isAmPmFormat
                    ? formatTimeStringAmPmFormat(flight.flightlegs[0].deptime)
                    : formatTimeString(flight.flightlegs[0].deptime)}
                </span>
                <span className="depTerminal">
                  {getTerminal(
                    flight.flightlegs[0].origin,
                    flight.flightlegs[0].depterminal,
                  )}
                </span>
              </div>
            </Col>
            <Col
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className="d-flex justify-content-center  px-0"
            >
              <div className="d-flex flex-column text-center">
                <span className="fs-12 fw-500 grey-color flightDuration">
                  {convertTravelTime(flight.totaljourneyduration)}
                </span>
                <StopOverInfo flight={flight} hideLegInfo={hideLegInfo} />
              </div>
            </Col>
            <Col
              lg={5}
              md={5}
              sm={5}
              xs={5}
              className="d-flex justify-content-end"
            >
              <div className="d-flex flex-column text-end">
                <span className="title fw-600 arrTime">
                  {isAmPmFormat
                    ? formatTimeStringAmPmFormat(
                        flight.flightlegs[flight.flightlegs.length - 1].arrtime,
                      )
                    : formatTimeString(
                        flight.flightlegs[flight.flightlegs.length - 1].arrtime,
                      )}
                  {flight.flightlegs[0].depdate !==
                    flight.flightlegs[flight.flightlegs.length - 1].arrdate && (
                    <span className="extra-days">+1</span>
                  )}
                </span>
                <span className="arrTerminal">
                  {getTerminal(
                    flight.flightlegs[flight.flightlegs.length - 1].destination,
                    flight.flightlegs[flight.flightlegs.length - 1].arrterminal,
                  )}
                </span>
              </div>
            </Col>
          </Row>
        ) : (
          <Row className="spacing-8">
            <Col xs={6}>
              <div className="d-flex flex-column">
                <span className="title fw-600">
                  {formatTimeString(flight.flightlegs[0].deptime)}
                </span>
                <span className="fs-12 fw-300 grey-color">
                  {convertTravelTime(flight.totaljourneyduration)}
                </span>
              </div>
            </Col>
            <Col xs={6}>
              <div className="d-flex flex-column text-center">
                <span className="title fw-600">
                  {formatTimeString(
                    flight.flightlegs[flight.flightlegs.length - 1].arrtime,
                  )}
                  {flight.flightlegs[0].depdate !==
                    flight.flightlegs[flight.flightlegs.length - 1].arrdate && (
                    <span className="extra-days">+1</span>
                  )}
                </span>
                <span className="fs-12 fw-300 grey-color">
                  <StopOverInfo flight={flight} hideLegInfo={hideLegInfo} />
                </span>
              </div>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
}
